module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-6.jpg?v=9beecdf4";